import { sanityClient } from '@/content/sanity/sanity-client/sanity-client';
import imageUrlBuilder from '@sanity/image-url';
import { SanityImageSource } from '@sanity/image-url/lib/types/types';

const builder = imageUrlBuilder(sanityClient);

export const urlFor = (source: SanityImageSource) => {
  return builder.image(source);
};

export const getDiscoverExperiencesContent = async () => {
  const query = `*[_type == "discoverExperiences"][0]{
      ...,
      section3{
        ...,
        "experiences": experiences[]->{
          _id,
          name,
          title,
          detail,
          link,
          video,
          steps,
          icon,
          experienceType,
          platform,
          mobileTitleOverride,
          mobileDetailOverride
        }
      }
    }`;
  const content = await sanityClient.fetch(query);
  return content;
};
